<template>
    <section class="main-section">
        <v-container class="container--large">
            <div v-if="title" class="tit-wrap justify-center text-center">
                <h2 class="main-tit">{{ title }}</h2>
            </div>
            <slot />
        </v-container>
    </section>
</template>

<script>
export default {
    props: {
        title: String
    },
    data(){
        return{
        }
    },
};
</script>
<style scoped>
.main-section{
    padding: 60px 0;
}
@media (min-width:576px){
}
@media (min-width:768px){
    .main-section{
        padding: 100px 0;
    }
}
@media (min-width:1024px){
    .main-section{
        padding: 140px 0;
    }
}
@media (min-width:1200px){
}

</style>